import React, { memo } from 'react';
const bonuses = [{
  num: 1,
  title: 'SISTEMA DE FICHAS PROFESIONALES™',
  desc: 'Plantillas listas para organizar mejor información clave de clientas.',
  price: '$8.000 ARS'
}, {
  num: 2,
  title: 'SCRIPTS DE RESPUESTA PROFESIONAL™',
  desc: 'Respuestas estructuradas para situaciones frecuentes.',
  price: '$9.000 ARS'
}, {
  num: 3,
  title: 'CHECKLISTS OPERATIVOS EXPRESS™',
  desc: 'Checklists para reducir errores y sostener orden.',
  price: '$7.000 ARS'
}, {
  num: 4,
  title: 'SISTEMA SIMPLE DE AGENDA Y SEGUIMIENTO™',
  desc: 'Herramientas para organizar citas y continuidad.',
  price: '$6.000 ARS'
}, {
  num: 5,
  title: 'KIT DE SITUACIONES DIFÍCILES™',
  desc: 'Recursos para reclamos, objeciones y situaciones incómodas.',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'KIT EXPERIENCIA PREMIUM™',
  desc: 'Recursos para elevar experiencia clienta y percepción profesional.',
  price: '$8.000 ARS'
}];
export function BonusSection() {
  return <section className="bg-brand-grayLight py-16 px-5 relative" data-id="element-26">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4 leading-tight" data-id="element-29">
            🎁 ADEMÁS RECIBÍS ESTOS{' '}
            <span className="text-brand-primary" data-id="element-30">BONOS ESTRATÉGICOS</span> SIN
            COSTO
          </h2>
          <p className="text-xs text-slate-400 font-bold uppercase tracking-widest" data-id="element-31">
            Diseñados para ayudarte a IMPLEMENTAR más rápido
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 mb-10" data-id="element-32">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white border border-slate-100 rounded-2xl p-6 relative overflow-hidden transition-all hover:shadow-lg hover:border-brand-primary/30" data-id="element-33">
              <div className="absolute top-4 right-4 bg-brand-accent/20 text-amber-700 text-[10px] font-black px-3 py-1 rounded-full flex items-center gap-1" data-id="element-34">
                🎁 GRATIS
              </div>

              <div className="flex items-center gap-4 mb-4" data-id="element-35">
                <div className="bg-brand-primary/10 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-36">
                  <span className="text-xl" data-id="element-37">🎁</span>
                </div>
                <span className="text-[11px] text-slate-400 font-bold uppercase tracking-wider" data-id="element-38">
                  BONO {bonus.num}
                </span>
              </div>

              <h3 className="text-lg font-black text-slate-900 mb-2 pr-20" data-id="element-39">
                {bonus.title}
              </h3>
              <p className="text-sm text-slate-500 mb-4 leading-relaxed" data-id="element-40">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-3" data-id="element-41">
                <span className="text-sm text-slate-300 line-through font-medium" data-id="element-42">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-600 bg-green-50 px-2 py-0.5 rounded" data-id="element-43">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-white border-2 border-brand-primary/20 rounded-2xl p-8 text-center shadow-sm" data-id="element-44">
          <p className="text-slate-400 text-sm line-through mb-1 font-medium" data-id="element-45">
            Valor total bonos: +$45.000 ARS
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-primary" data-id="element-46">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-slate-400 mt-2 font-bold uppercase tracking-tighter" data-id="element-47">
            (solo mientras esta oferta esté activa)
          </p>
        </div>
      </div>
    </section>;
}